export default function getOverflowedEdges(target: HTMLElement) {
  const targetBoundaries = target.getBoundingClientRect();
  const overflowedEdges = {
    top: false,
    right: false,
    bottom: false,
    left: false,
  };

  if (targetBoundaries.top < 0) {
    overflowedEdges.top = true;
  }

  if (
    targetBoundaries.right >
    (window.visualViewport?.width || document.documentElement.clientWidth)
  ) {
    overflowedEdges.right = true;
  }

  if (
    targetBoundaries.bottom >
    (window.visualViewport?.height || document.documentElement.clientHeight)
  ) {
    overflowedEdges.bottom = true;
  }

  if (targetBoundaries.left < 0) {
    overflowedEdges.left = true;
  }

  return overflowedEdges;
}
